import { Column } from '../../../../components/Table/Column';

const columns: Column[] = [{
  key: 'name',
  align: 'left',
  size: 9,
}];

export default columns;
